module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon6.5da75f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon6.png
// module id = Vzb5
// module chunks = 0